import { render, staticRenderFns } from "./NameHeart.vue?vue&type=template&id=1134db26&scoped=true&"
import script from "./NameHeart.vue?vue&type=script&lang=js&"
export * from "./NameHeart.vue?vue&type=script&lang=js&"
import style0 from "./NameHeart.vue?vue&type=style&index=0&id=1134db26&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1134db26",
  null
  
)

export default component.exports